import { useCallback } from 'react';

import { IBackendCartEntries, ILegacyCartEntry } from '@rbi-ctg/menu';
import { useFeatureFoodwareQuery } from 'generated/sanity-graphql';
import { withSimpleCache } from 'state/graphql/with-simple-cache';
import { isBackendCartEntry } from 'utils/cart-utils';

const FEATURE_FOODWARE_SINGLETON_ID = 'feature-foodware-singleton';

const useFoodware = () => {
  const cachedFeatureFoodwareQuery = withSimpleCache(useFeatureFoodwareQuery);

  const { data, loading } = cachedFeatureFoodwareQuery({
    variables: {
      featureFoodwareId: FEATURE_FOODWARE_SINGLETON_ID,
    },
  });

  const isFoodware = useCallback(
    (cartEntry: ILegacyCartEntry | IBackendCartEntries): boolean => {
      if (!cartEntry) {
        return false;
      }

      if (!cartEntry?.isExtra || !data?.FeatureFoodware?.items?.length) {
        return false;
      }

      return (
        data?.FeatureFoodware?.items.findIndex(item => {
          const cartEntryId = isBackendCartEntry(cartEntry) ? cartEntry.sanityId : cartEntry._id;
          return item?._id === cartEntryId;
        }) > -1
      );
    },
    [data?.FeatureFoodware?.items]
  );

  return {
    isFoodware,
    featureFoodware: data?.FeatureFoodware,
    loading,
  };
};

export default useFoodware;
